// src/constants/categories.js
export const CATEGORY_OPTIONS = [
  'カフェ','レストラン','居酒屋','バー','ラーメン','うどん/そば','寿司','焼肉','和食','洋食','中華','カレー','ファストフード','スイーツ','ベーカリー',
  'コンビニ','スーパー','ドラッグストア','家電量販店','書店','アパレル','雑貨','ホームセンター','家具/インテリア','スポーツ用品','百貨店/ショッピングモール',
  '美容室/理容室','ネイルサロン','エステ','マッサージ/整体','クリニック/病院','薬局','クリーニング','コインランドリー',
  'ホテル/旅館','レジャー/アミューズメント','フィットネス/ジム','教育/スクール','交通/タクシー','観光/チケット','イベント','その他'
];
